// ** React Imports
import { useEffect } from 'react';
import logo_seia from '@src/assets/images/logo/logo_seia.png';
import { NavLink } from 'react-router-dom';

// ** Third Party Components
// import { Disc, X, Circle } from 'react-feather';

// ** Config
import themeConfig from '@configs/themeConfig';

const VerticalMenuHeader = (props) => {
	// ** Props
	const { menuCollapsed, setGroupOpen, menuHover } = props;

	// ** Reset open group
	useEffect(() => {
		if (!menuHover && menuCollapsed) setGroupOpen([]);
	}, [menuHover, menuCollapsed]);

	// ** Menu toggler component
	/*const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(true)}
        />
      )
    } else {
      return (
        <Circle
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(false)}
        />
      )
    }
  }*/

	return (
		<div className="navbar-header d-flex justify-content-center align-items-center">
			<ul className="nav navbar-nav flex-row ">
				<li className="nav-item mr-2 ">
					<NavLink to="/">
						<span>
							<img src={logo_seia} alt="logo" />
						</span>
					</NavLink>
				</li>
				<li className="nav-item nav-toggle" />
			</ul>
		</div>
	);
};

export default VerticalMenuHeader;
